module.exports = __webpack_public_path__ + "media/app/components/RatingModal/Mascot-5.93c5b2dc.svg";